export const T = {
  en_GB: {
    name: "Name",
    isin: "ISIN",
    currency: "Currency",
    status: "Status",
    notComputed: "Not computed yet",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    viewChart: "View chart",
    noInstruments: "No combined instruments found.",
    previous: "Previous",
    next: "Next",
  },
  nb_NO: {
    name: "Navn",
    isin: "ISIN",
    currency: "Valuta",
    status: "Status",
    notComputed: "Ikke beregnet ennå",
    actions: "Handlinger",
    edit: "Rediger",
    delete: "Slett",
    viewChart: "Se diagram",
    noInstruments: "Ingen kombinerte instrumenter funnet.",
    previous: "Forrige",
    next: "Neste",
  },
} as const;
